import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
const BoostNotSupportedModal = ({ onRequestClose })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: true,
        variant: "vertical",
        image: /*#__PURE__*/ React.createElement(Warning, null),
        onRequestClose: onRequestClose,
        title: t('boostDeviation.notSupportedModal.title'),
        message: t('boostDeviation.notSupportedModal.message'),
        footerButtons: [
            /*#__PURE__*/ React.createElement(ConfirmButton, {
                key: "confirm",
                onClick: onRequestClose
            }, t('common.gotIt'))
        ]
    });
};
BoostNotSupportedModal.displayName = 'BoostNotSupportedModal';
export default BoostNotSupportedModal;

//# sourceMappingURL=BoostNotSupportedModal.js.map